import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Features from "@/pages/Features";
import IndustriesPage from "@/pages/Industries";
import Pricing from "@/pages/Pricing";
import CustomDevelopment from "@/pages/CustomDevelopment";
import Integrations from "@/pages/Integrations";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQPage from "@/pages/FAQ";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import ModuleLanding from "@/pages/ModuleLanding";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/custom-development" element={<CustomDevelopment />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/software/:slug" element={<ModuleLanding />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
